import { Injectable } from '@angular/core';
import { FirebaseAnalytics } from '@ionic-native/firebase-analytics/ngx';
import { Platform } from '@ionic/angular';
import firebase from 'firebase/app';
import 'firebase/analytics'; // 👈 Asegura importar esto
import { environment } from '@env/environment';

const firebaseConfig = environment.firebase;

// Inicializar Firebase solo si no está inicializado
if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}
const analyticsWeb = firebase.analytics(); // 👈 Usando Firebase 7

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {
  constructor(
    private firebaseAnalytics: FirebaseAnalytics,
    private platform: Platform
  ) {}

  logEvent(eventName: string, params: any): Promise<any> {
    if (this.platform.is('cordova')) {
      return this.firebaseAnalytics.logEvent(`TRUE_${eventName}`, params);
    } else {
      analyticsWeb.logEvent(`TRUE_${eventName}`, params);
      return Promise.resolve();
    }
  }

  /**
   * Establecer propiedades del usuario (Móvil + Web)
   */
  setUserProperties(properties: { [key: string]: string }): Promise<any> {
    if (this.platform.is('cordova')) {
      const promises = Object.keys(properties).map(key => {
        return this.firebaseAnalytics.setUserProperty(key, properties[key]);
      });
      return Promise.all(promises);
    } else {
      return Promise.resolve();
    }
  }
}
